// =======================================================
// Quick Access
// =======================================================
// Variable
const quickAContainer = document.querySelector('.quick-a__container');
const quickAClose = document.querySelector('.quick-a__close');
const quickAOpen = document.querySelector('.quick-a__open');
const quickA = document.querySelector('.quick-a');

// Event
quickAClose.addEventListener('click', () => {
    quickAContainer.classList.remove('quick-open');
    quickA.classList.remove('quick-a--open');
});

quickAOpen.addEventListener('click', () => {
    quickAContainer.classList.add('quick-open');
    quickA.classList.add('quick-a--open');
});


